//* 组件库
import type { UiTableOption2 } from "various-ui";
import type { LayoutProps } from "../../../index";
export const useOptions = (define: LayoutProps) => {
    //* 插件
    const i18n = useI18n();
    //* 数据初始化
    const info = <UiTableOption2[]>[
        { key: "id", name: i18n.t("ModelAllele"), align: "center" },
        { key: "strain", name: i18n.t("StrainOrigin"), align: "center" },
        { key: "type", name: i18n.t("AlleleType"), align: "center" },
        { key: "mutation", name: i18n.t("Mutation"), align: "center" },
        { key: "inheritance", name: i18n.t("Inheritance"), align: "center" },
        define.info.related_genes.length
            ? { key: "genes", name: i18n.t("Layout.TypeRelated", { type: "Gene" }), align: "center" }
            : { key: "gene_expressions", name: i18n.t("GeneExpression", 2), align: "center" },
        { key: "disease", name: i18n.t("Layout.TypeRelated", { type: "Disease" }), align: "center" },
        { key: "references", name: i18n.t("Reference"), align: "center" },
    ];

    if (define.info.mgi) {
        info.splice(2, 0, { key: "mgi", name: i18n.t("StrainMGIID"), align: "center" });
    }

    return {
        info: info,
    };
};
